import { MainState } from './types';

const state: MainState = {
    loading: false,
    lang: 'en'
}
export default {
    namespaced: true,
    state,
    mutations: {
        SET_LOADING(state: MainState, loading: boolean) {
            state.loading = loading;
        },
        SET_LANG(state: MainState, lang: string) { 
            state.lang = lang;
        }
    },
    actions: {
    }
}